import {Core} from '@strapi/strapi';
import {KoniBotActionType} from "./services/bot/koni-bot-action";
import {KoniBotServiceType} from "./services/bot/koni-bot";
import path from "path";
import fs from "fs";
import {SynchronizeActionServiceType} from "./services/bot/synchronize-action";

export default async ({strapi}: { strapi: Core.Strapi }) => {
  // Init botMap
  strapi.plugin('telegram-bot').service<KoniBotServiceType>('koniBot').botMap;
  const enableDefaultAction = strapi.plugin('telegram-bot').config('registerDefaultActions', false);

  strapi.log.info(`Enable default action: ${enableDefaultAction}`);
  if (enableDefaultAction) {
    await strapi.plugin('telegram-bot').service<KoniBotActionType>('koniBotAction').registerBotActions();
  }

  await strapi.plugin('telegram-bot').service<SynchronizeActionServiceType>('synchronizeAction').registerCrawlerBotActions();

  // Documentations
  if (strapi.plugin('documentation')) {
    const specPath = path.join(__dirname, '../../documentation/content-api.yaml');
    const spec = fs.readFileSync(specPath, 'utf8');

    strapi
      .plugin('documentation')
      .service('override')
      .registerOverride(spec, {
        pluginOrigin: 'telegram-bot',
        excludeFromGeneration: ['telegram-bot'],
      });
  }
};
